import { SendableInvoice } from 'types/invoices';

/** The e-mail send's rule for whether the specification goes along as a file of its own. */
export const isSpecAttachedByDefault = (invoice: SendableInvoice): boolean =>
    !invoice.isFixedFeeMattersOnly &&
    invoice.isSpecAvailable &&
    !invoice.isSpecIncludedInInvoice &&
    !invoice.isSpecExcludedFromEmail;
